import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AlertIcon } from '@/shared/assets/icons/alert-icon';
import { Chip } from '@/shared/components/ui/chip/chip';
import { useDateUtils } from '@/shared/hooks/use-date-utils/use-date-utils';
import { useReadSubscriptionStatusQuery } from '@/shared/redux/api/billing/billing-api';

export const TrialExpired: React.FC = () => {
  const { t } = useTranslation();
  const { formatLocalTime } = useDateUtils();
  const { data } = useReadSubscriptionStatusQuery();
  const expirationTs = data?.subscriptionStatus.expirationTs;
  const planType = data?.subscriptionStatus.planType;

  const showExpiredBadge = () => {
    if (!expirationTs) {
      return false;
    }

    const expiredDate = new Date(expirationTs * 1000);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    expiredDate.setHours(0, 0, 0, 0);

    return expiredDate <= today;
  };

  if (planType !== 'TRIAL' || !showExpiredBadge()) {
    return null;
  }

  return (
    <Stack alignItems="center" justifyContent="center">
      <Chip
        tooltip={t('auth:trial_expired_tooltip', {
          timestamp: formatLocalTime(expirationTs),
        })}
        status="red"
        label={
          <Stack
            padding="0.25rem"
            direction="row"
            gap="0.5rem"
            alignItems="center"
          >
            <AlertIcon />
            <Typography variant="p7">{t('auth:trial_expired')}</Typography>
          </Stack>
        }
      />
    </Stack>
  );
};
